import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ApprovalItem {
  approvalLinkId: string;
  projectId: number;
  parentModule: "Task" | "Issue";
  approvalStage: "Checker" | "Approver" | "Verifier";
  entityId: number;
  entityName: string;
  entityOwnerId: number;
  entityOwnerName: string;
  entityTags: { tagName: string }[];
  startDate: string;
  submissionDate: string;
  completionPercentage: number | "NA";
  updates?: any;
  stateApprovals?: any[];
}

interface WorkApprovalsState {
  data: ApprovalItem[];
  selectedEntity: ApprovalItem | null;
}

const initialState: WorkApprovalsState = {
  data: [],
  selectedEntity: null,
};

const workApprovalsSlice = createSlice({
  name: "workApprovals",
  initialState,
  reducers: {
    setWorkApprovalsData(state, action: PayloadAction<ApprovalItem[]>) {
      state.data = action.payload;
    },
    setSelectedEntity(state, action: PayloadAction<ApprovalItem | null>) {
      state.selectedEntity = action.payload;
    },
    clearSelectedEntity(state) {
      state.selectedEntity = null;
    },
    approveWorkItem(state, action: PayloadAction<{ approvalLinkId: string }>) {
      const { approvalLinkId } = action.payload;
      state.data = state.data.filter(item => item.approvalLinkId !== approvalLinkId);
    },
  },
});

export const {
  setWorkApprovalsData,
  setSelectedEntity,
  clearSelectedEntity,
  approveWorkItem,
} = workApprovalsSlice.actions;

export default workApprovalsSlice.reducer;